<template>
  <div class="flex w-full justify-between text-sm pl-2" :class="coupon.pivot.redeemed ? 'text-gray-400' : ''">
    <div class="w-1/5">
      {{ coupon.code }}
    </div>
    <div class="w-1/3">
      {{ coupon.description }}
    </div>
    <div class="w-1/5 text-center">
      {{ couponValue }}
    </div>
    <div class="w-1/4 text-center">
      {{ coupon.max_number_of_uses > 0 ?
       coupon.pivot.usage_counter + ' / '+ coupon.max_number_of_uses : $t('coupons.exhaustion') }}
    </div>
    <div class="w-1/4 text-right" v-if="!coupon.is_expired">
      {{ expireDate }}
    </div>
    <div v-else>
      {{ $t('coupons.expired') }}
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  props: ['coupon'],

  computed: {
    couponValue() {
      if (this.coupon.type === 'P') {
        return `${this.coupon.value}%`;
      }
      return this.formatter.format(this.coupon.pivot.deducted_value / 100);
    },

    expireDate() {
      return dayjs(this.coupon.expire_date).format('MM/DD/YYYY');
    },
  },
};
</script>
